const cardItems = [
  {
    title: '某知名艺人涉税风波再起波澜',
    desc: '近日有消息称某一线艺人再次卷入税务风波，相关细节引发网友热议与多方猜测。',
    tag: '娱乐圈',
    time: '2小时前',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20art%20with%20deep%20burgundy%20and%20warm%20gold%20tones%2C%20geometric%20shapes%20representing%20entertainment%20industry%2C%20cinematic%20mood%2C%20soft%20gradients%2C%20no%20text%2C%20editorial%20style&width=800&height=500&seq=cards-item-1&orientation=landscape',
  },
  {
    title: '网红情侣分手互爆黑料',
    desc: '一对知名网红情侣高调分手后互相爆料对方私生活，双方粉丝阵营激烈交锋持续升级。',
    tag: '网红圈',
    time: '4小时前',
    img: 'https://readdy.ai/api/search-image?query=Warm%20coral%20and%20amber%20abstract%20composition%2C%20flowing%20lines%20and%20soft%20shapes%2C%20modern%20digital%20media%20aesthetic%2C%20cinematic%20lighting%2C%20no%20text%2C%20dramatic%20atmosphere&width=800&height=500&seq=cards-item-2&orientation=landscape',
  },
  {
    title: '综艺录制花絮意外曝光',
    desc: '某热门综艺录制现场突发状况，花絮视频意外流出，揭露节目背后不为人知的真实一面。',
    tag: '综艺',
    time: '6小时前',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20visual%20with%20terracotta%20and%20bronze%20hues%2C%20layered%20shapes%20and%20textures%2C%20entertainment%20industry%20theme%2C%20cinematic%20editorial%20style%2C%20no%20text%2C%20warm%20lighting&width=800&height=500&seq=cards-item-3&orientation=landscape',
  },
  {
    title: '某选秀节目导师被曝不当言论',
    desc: '选秀节目评委在私下聚会中的不当言论录音被曝光，引发网友对节目公信力的强烈质疑。',
    tag: '综艺',
    time: '8小时前',
    img: 'https://readdy.ai/api/search-image?query=Deep%20crimson%20and%20warm%20gold%20abstract%20gradient%2C%20geometric%20patterns%20representing%20media%20and%20news%2C%20dramatic%20cinematic%20mood%2C%20no%20text%2C%20modern%20editorial%20design&width=800&height=500&seq=cards-item-4&orientation=landscape',
  },
  {
    title: '知名导演新片选角内幕流出',
    desc: '某大导演新片选角过程中的内幕消息流出，多位演员之间的角色竞争引发广泛讨论。',
    tag: '娱乐圈',
    time: '10小时前',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20burgundy%20abstract%20art%2C%20flowing%20organic%20shapes%2C%20film%20industry%20theme%2C%20cinematic%20lighting%20and%20mood%2C%20no%20text%2C%20editorial%20photography%20style&width=800&height=500&seq=cards-item-5&orientation=landscape',
  },
  {
    title: '某品牌代言人突然解约',
    desc: '知名品牌与代言人的合作关系突然终止，双方声明各执一词，背后真实原因成谜引热议。',
    tag: '商业圈',
    time: '12小时前',
    img: 'https://readdy.ai/api/search-image?query=Sophisticated%20abstract%20composition%20in%20warm%20red%20and%20gold%20tones%2C%20layered%20geometric%20elements%2C%20business%20and%20media%20theme%2C%20cinematic%20editorial%20style%2C%20no%20text%2C%20dramatic%20mood&width=800&height=500&seq=cards-item-6&orientation=landscape',
  },
  {
    title: '某女星深夜发文引发猜测',
    desc: '一位知名女星深夜发布意味深长的社交媒体动态，粉丝纷纷解读暗藏信息，事态持续发酵。',
    tag: '娱乐圈',
    time: '14小时前',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20art%20with%20coral%20and%20deep%20gold%20hues%2C%20soft%20flowing%20shapes%2C%20celebrity%20and%20media%20theme%2C%20cinematic%20mood%2C%20no%20text%2C%20modern%20editorial%20design%2C%20warm%20lighting&width=800&height=500&seq=cards-item-7&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1150px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门爆料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          最新最热的51吃瓜爆料内容汇总
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className={`bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer group ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="relative aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <span className="absolute top-3 left-3 inline-flex items-center px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}